<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title
        >温湿度标准设置
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            icon="el-icon-delete"
            @click="handleBatchDeleteUser"
            title="批量删除"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            icon="el-icon-plus"
            title="添加"
            v-if="operationSuper.编辑"
            @click="handleHumitureStandard('add')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->

    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.alarmIdList" class="form-item_2">
            <el-select
              v-model="slotForms.forms.alarmIdList"
              clearable
              filterable
              placeholder="温湿度标准"
            >
              <el-option
                v-for="item in humitureTree"
                :key="item.alarmId"
                :label="item.tempAndHumidityStandardName"
                :value="item.alarmId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="forms.isUse">
            <el-select
              v-model="slotForms.forms.isUse"
              clearable
              placeholder="是否启用"
            >
              <el-option label="未启用" :value="0"></el-option>
              <el-option label="已启用" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->

    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          label="序号"
          align="center"
          type="index"
          width="55"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          min-width="130"
          align="center"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
        <!--<el-table-column-->
        <!--prop="tempAndHumidityStandardName"-->
        <!--label="温湿度标准名称"-->
        <!--header-align="center"-->
        <!--show-overflow-tooltip-->
        <!--align="left"-->
        <!--min-width="140"-->
        <!--&gt;</el-table-column>-->
        <!--<el-table-column-->
        <!--prop="companyName"-->
        <!--label="企业名称"-->
        <!--header-align="center"-->
        <!--show-overflow-tooltip-->
        <!--align="left"-->
        <!--min-width="140"-->
        <!--&gt;</el-table-column>-->
        <!--<el-table-column-->
        <!--prop="temperatureRequire"-->
        <!--label="温度要求"-->
        <!--header-align="center"-->
        <!--show-overflow-tooltip-->
        <!--align="left"-->
        <!--min-width="120"-->
        <!--&gt;</el-table-column>-->
        <!--<el-table-column-->
        <!--prop="humidityRequire"-->
        <!--label="湿度要求"-->
        <!--header-align="center"-->
        <!--show-overflow-tooltip-->
        <!--align="left"-->
        <!--min-width="120"-->
        <!--&gt;</el-table-column>-->
        <!--<el-table-column-->
        <!--prop="temperatureAlarmArg"-->
        <!--label="温度报警参数"-->
        <!--header-align="center"-->
        <!--show-overflow-tooltip-->
        <!--align="left"-->
        <!--min-width="220"-->
        <!--&gt;</el-table-column>-->
        <!--<el-table-column-->
        <!--prop="humidityAlarmArg"-->
        <!--label="湿度报警参数"-->
        <!--header-align="center"-->
        <!--show-overflow-tooltip-->
        <!--align="left"-->
        <!--min-width="220"-->
        <!--&gt;</el-table-column>-->
        <!--<el-table-column-->
        <!--prop="isAndNotUse"-->
        <!--label="是否启用"-->
        <!--header-align="center"-->
        <!--show-overflow-tooltip-->
        <!--align="center"-->
        <!--min-width="80"-->
        <!--&gt;</el-table-column>-->
        <el-table-column
          align="center"
          label="操作"
          width="90"
          class-name="operate"
        >
          <template slot-scope="{ row }">
            <span
              class="item"
              @click="handleHumitureStandard('change', row.alarmId)"
              >修改</span
            >
            <span class="item" @click="handelDelete(row.alarmId)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->

    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->

    <!-- 新增/修改温湿度标准 -->
    <el-dialog
      class="standard-dialog"
      :title="`${dialogTitle}温湿度标准`"
      :visible.sync="dialogVisible"
      width="35%"
      :close-on-click-modal="false"
    >
      <div v-loading="dialogLoding">
        <span
          ><el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="ruleForm"
          >
            <el-form-item label="全部启用" required class="temp-require">
              <el-col :span="5">
                <el-form-item prop="isUse"
                  ><el-switch v-model="ruleForm.isUse"> </el-switch
                ></el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item prop="isUseRange"
                  ><el-checkbox v-model="ruleForm.isUseRange"
                    >范围</el-checkbox
                  ></el-form-item
                >
              </el-col>
              <el-col :span="5">
                <el-form-item prop="isUseDuration"
                  ><el-checkbox v-model="ruleForm.isUseDuration"
                    >时长</el-checkbox
                  ></el-form-item
                >
              </el-col>
            </el-form-item>
            <el-form-item
              label="标准名称"
              class="name"
              prop="tempAndHumidityStandardName"
            >
              <el-input
                v-model.trim="ruleForm.tempAndHumidityStandardName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="温度是否启用" prop="temperatureIsUse"
              ><el-switch v-model="ruleForm.temperatureIsUse"> </el-switch
            ></el-form-item>
            <el-form-item label="温度要求" required class="temp-require">
              <el-col :span="7">
                <el-form-item prop="tempLow" class="require">
                  <el-input
                    v-model.trim="ruleForm.tempLow"
                    clearable
                    placeholder="下限"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">至</el-col>
              <el-col :span="6">
                <el-form-item prop="tempHigh" class="require">
                  <el-input
                    v-model="ruleForm.tempHigh"
                    clearable
                    placeholder="上限"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="3">℃</el-col>
            </el-form-item>
            <el-form-item label="温度报警" class="temp-require alarmRule">
              <span v-if="ruleForm.isUseRange">
                <el-col class="line" :span="7">超出正常温度上限</el-col>
                <el-col :span="6">
                  <el-form-item prop="outTempHigh" class="require">
                    <el-input
                      v-model.trim="ruleForm.outTempHigh"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="9">℃</el-col>

                <el-col class="line" :span="7">超出正常温度下限</el-col>
                <el-col :span="6">
                  <el-form-item prop="outTempLow" class="require">
                    <el-input
                      v-model.trim="ruleForm.outTempLow"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="9">℃</el-col>
              </span>
              <span v-else>
                <el-col class="line" :span="7">超出正常温度范围</el-col></span
              >
              <span v-if="ruleForm.isUseDuration">
                <el-col class="line" :span="3"> 且持续</el-col>
                <el-col :span="6">
                  <el-form-item prop="tempContinuedTime" class="require">
                    <el-input
                      v-model.trim="ruleForm.tempContinuedTime"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="4">分钟以上</el-col>
              </span>
            </el-form-item>
            <el-form-item
              label="湿度是否启用"
              style="margin-top: -18px"
              prop="humidityIsUse"
              ><el-switch v-model="ruleForm.humidityIsUse"> </el-switch
            ></el-form-item>

            <el-form-item label="湿度要求" class="hum-require">
              <el-col :span="7">
                <el-form-item prop="humidityLow" class="require">
                  <el-input
                    v-model.trim.number="ruleForm.humidityLow"
                    clearable
                    placeholder="下限"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">至</el-col>
              <el-col :span="6">
                <el-form-item prop="humidityHigh" class="require">
                  <el-input
                    v-model.trim.number="ruleForm.humidityHigh"
                    clearable
                    placeholder="上限"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="4">%RH</el-col>
            </el-form-item>
            <el-form-item label="湿度报警" class="temp-require alarmRule">
              <span v-if="ruleForm.isUseRange">
                <el-col class="line" :span="7">超出正常湿度上限</el-col>
                <el-col :span="6">
                  <el-form-item prop="outHumidityHigh" class="require">
                    <el-input
                      v-model.trim="ruleForm.outHumidityHigh"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="9">%RH</el-col>

                <el-col class="line" :span="7">超出正常湿度下限</el-col>
                <el-col :span="6">
                  <el-form-item prop="outHumidityLow" class="require">
                    <el-input
                      v-model.trim="ruleForm.outHumidityLow"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="9">%RH</el-col>
              </span>
              <span v-else>
                <el-col class="line" :span="7">超出正常湿度范围</el-col></span
              >
              <span v-if="ruleForm.isUseDuration">
                <el-col class="line" :span="3"> 且持续</el-col>
                <el-col :span="6">
                  <el-form-item prop="humidityContinuedTime" class="require">
                    <el-input
                      v-model.trim="ruleForm.humidityContinuedTime"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="4">分钟以上</el-col>
              </span>
            </el-form-item>
            <div class="operates-btn">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="handleSubmit()"
                >确 定</el-button
              >
            </div>
          </el-form>
        </span>
      </div>
    </el-dialog>
    <!-- 新增/修改温湿度标准  end -->
  </div>
</template>

<script>
//global variable
let HUMITURE_NAME = []; //温湿度标准名称

// Interface
import {
  FetchFindByPage,
  FetchHumitureName,
  findTempAndHumiditySetInfoById, // 获取温湿度标准设置信息接口
  saveTempAndHumiditySet, // 新增 or 修改 新增温湿度标准设置接口
  deleteTempAndHumiditySetByIdList // 删除温湿度标准设置接口
} from "@/api/systemSetting/humitureStandardSet";

// Plugs
import cloneDeep from "lodash/cloneDeep";

// Vuex
import { mapGetters } from "vuex";

// Mixins
import resizeListener from "_private/mixins/resizeListener";

import operationManage from "_private/mixins/operationManage";

// Js
import { mergeFormExtend } from "_private/utils/merge";
import {
  FetchGetTableColumnSettings,
  FetchSaveUserTableColumnSettings
} from "_private/api/public.js";
export default {
  mixins: [resizeListener, operationManage],

  data() {
    // 标准名称
    const humitureNameRule = (rule, value, callback) => {
      if (this.cname !== value && HUMITURE_NAME.includes(value)) {
        callback(new Error("名称已存在"));
      } else {
        callback();
      }
    };

    // 温度要求（下限）
    const tempDownRule = (rule, value, callback) => {
      // eslint-disable-next-line no-useless-escape
      let reg = /^(\-|\+)?\d+(\.\d{1})?$/;
      if (!isNaN(value)) {
        if (reg.test(value)) {
          if (Number(value) >= -80 && Number(value) <= 120) {
            if (this.ruleForm.tempHigh.length) {
              if (Number(value) > Number(this.ruleForm.tempHigh)) {
                callback(new Error("需低于最高温度"));
              } else {
                callback();
              }
            } else {
              callback();
            }
          } else {
            callback(new Error("范围-80℃~120℃"));
          }
        } else {
          callback(new Error("小数点后最多一位"));
        }
      } else {
        callback(new Error("请输入数字类型值"));
      }
    };

    // 温度要求（上限）
    const tempTopRule = (rule, value, callback) => {
      // eslint-disable-next-line no-useless-escape
      let reg = /^(\-|\+)?\d+(\.\d{1})?$/;
      if (!isNaN(value)) {
        if (reg.test(value)) {
          if (Number(value) >= -80 && Number(value) <= 120) {
            if (this.ruleForm.tempLow.length) {
              if (Number(value) < Number(this.ruleForm.tempLow)) {
                callback(new Error("需高于最低温度"));
              } else {
                callback();
              }
            } else {
              callback();
            }
          } else {
            callback(new Error("范围-80℃~120℃"));
          }
        } else {
          callback(new Error("小数点后最多一位"));
        }
      } else {
        callback(new Error("请输入数字类型值"));
      }
    };

    // 湿度要求（下限）
    const humDownRule = (rule, value, callback) => {
      if (value !== "") {
        if (!isNaN(value)) {
          if (Number(value) >= 1 && Number(value) <= 100) {
            if (this.ruleForm.humidityHigh) {
              if (Number(value) > Number(this.ruleForm.humidityHigh)) {
                callback(new Error("需低于最高湿度"));
              } else {
                callback();
              }
            } else {
              callback();
            }
          } else {
            callback(new Error("范围1~100的整数"));
          }
        } else {
          callback(new Error("请输入数字类型值"));
        }
      } else {
        callback();
      }
    };

    // 湿度要求（上限）
    const humTopRule = (rule, value, callback) => {
      if (value !== "") {
        if (!isNaN(value)) {
          if (Number(value) >= 1 && Number(value) <= 100) {
            if (this.ruleForm.humidityLow) {
              if (Number(value) < Number(this.ruleForm.humidityLow)) {
                callback(new Error("需高于最低湿度"));
              } else {
                callback();
              }
            } else {
              callback();
            }
          } else {
            callback(new Error("范围1~100的整数"));
          }
        } else {
          callback(new Error("请输入数字类型值"));
        }
      } else {
        callback();
      }
    };

    // 温度报警
    const tempAlarmTimeRule = (rule, value, callback) => {
      if (value !== "") {
        if (!isNaN(value)) {
          if (value < 0) {
            callback(new Error("请输入非负整数"));
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入数字类型值"));
        }
      } else {
        callback();
      }
    };

    // 湿度报警
    const HumAlarmTimeRule = (rule, value, callback) => {
      if (value !== "") {
        if (!isNaN(value)) {
          if (value < 0) {
            callback(new Error("请输入非负整数"));
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入数字类型值"));
        }
      } else {
        callback();
      }
    };

    return {
      isSearch: false, // 查询框打开闭合
      loading: false, // 加载框

      // 查询条件
      formExtend: {
        forms: {
          alarmIdList: "", // 温湿度标准选择list
          isUse: "" // 是否启用温湿度标准
        },
        extends: []
      },

      humitureTree: [], // 温湿度标准下拉Tree
      formsExtend: [],
      tableData: [], // 表格数据
      total: 0, // 表格数据总数量
      curPage: 1, // 当前页码
      pageSize: 20, // 每页展示数据量
      multipleSelection: [], // 多选框

      dialogVisible: false, // 新增/修改温湿度标准弹框
      dialogTitle: "", // 新增/修改温湿度标准弹框标题
      dialogLoding: false, // 新增/修改温湿度标准loding

      // 新增/修改 温湿度标准表单
      ruleForm: {
        tempAndHumidityStandardName: "", // 标准名称
        tempHigh: "", // 温度上限
        tempLow: "", // 温度下限
        tempContinuedTime: "", //温度报警时间
        humidityHigh: "", // 湿度上限
        humidityLow: "", // 湿度下限
        humidityContinuedTime: "", // 湿度报警时间
        isUse: true, // 开关一
        temperatureIsUse: true, // 开关二
        humidityIsUse: true, // 开关三
        outTempLow: "",
        outTempHigh: "",
        outHumidityHigh: "",
        outHumidityLow: "",
        isUseRange: false,
        isUseDuration: false
      },
      showTableCols: [],
      hideTableCols: [],
      copyShowTableCols: [],
      copyHideTableCols: [],
      localShowTableCols: [],
      // 校验规则
      rules: {
        // 标准名称
        tempAndHumidityStandardName: [
          {
            required: true,
            message: "请输入名称",
            trigger: ["blur", "change"]
          },
          { max: 32, message: "不能超过32个字符", trigger: ["blur", "change"] },
          { validator: humitureNameRule, trigger: ["blur", "change"] }
        ],

        // 温度要求（上限）
        tempHigh: [
          {
            required: true,
            message: "请输入温度要求",
            trigger: ["change", "blur"]
          },
          { validator: tempTopRule, trigger: ["blur", "change"] }
        ],

        // 温度要求（下限）
        tempLow: [
          {
            required: true,
            message: "请输入温度要求",
            trigger: ["change", "blur"]
          },
          { validator: tempDownRule, trigger: ["blur", "change"] }
        ],

        // 湿度要求（上限）
        humidityHigh: [{ validator: humTopRule, trigger: ["blur", "change"] }],

        // 湿度要求（下限）
        humidityLow: [{ validator: humDownRule, trigger: ["blur", "change"] }],

        //温度报警
        tempContinuedTime: [
          { required: true, message: "请输入", trigger: "change" },
          { validator: tempAlarmTimeRule, trigger: ["blur", "change"] }
        ],

        // 湿度报警
        humidityContinuedTime: [
          { validator: HumAlarmTimeRule, trigger: ["blur", "change"] }
        ],
        //超出温度下限
        outTempLow: [
          { required: true, message: "请输入", trigger: "change" },
          { validator: tempAlarmTimeRule, trigger: ["blur", "change"] }
        ],
        //超出温度上限
        outTempHigh: [
          { required: true, message: "请输入", trigger: "change" },
          { validator: tempAlarmTimeRule, trigger: ["blur", "change"] }
        ],
        //超出湿度下限
        outHumidityLow: [
          { validator: HumAlarmTimeRule, trigger: ["blur", "change"] }
        ],
        //超出湿度上限
        outHumidityHigh: [
          { validator: HumAlarmTimeRule, trigger: ["blur", "change"] }
        ]
      },

      cname: "" // 当前缓存变量
    };
  },

  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"]),
    ids() {
      let ids = this.multipleSelection.map(item => {
        return item.alarmId;
      });
      return ids.length < 1 ? [] : ids;
    }
  },

  watch: {
    // 开关3
    "ruleForm.humidityIsUse"(val) {
      if (!val) {
        this.ruleForm.humidityHigh = "";
        this.ruleForm.humidityLow = "";
        this.ruleForm.outHumidityHigh = "";
        this.ruleForm.humidityContinuedTime = "";
        this.ruleForm.outHumidityLow = "";
      }
    }
  },

  created() {
    this.FetchHumitureName(); // 获取温湿度标准下拉Tree
    this.FetchFindByPage(this.mergeObj()); // 请求表格数据
    this.FetchGetTableColumnSettings({
      moduleId: this.moduleId,
      userId: this.userId
    });
  },

  methods: {
    // 获取字典下拉框
    FetchHumitureName() {
      FetchHumitureName()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            HUMITURE_NAME = [];
            this.humitureTree = response.result;
            this.humitureTree.forEach(item => {
              HUMITURE_NAME.push(item.tempAndHumidityStandardName);
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 获取表格数据
    FetchFindByPage(response) {
      this.loading = true;
      if (!response.alarmIdList) {
        response.alarmIdList = [];
      } else {
        response.alarmIdList = [response.alarmIdList];
      }

      FetchFindByPage(response)
        .then(response => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            this.tableData = response.result.data;
            this.total = response.result.totalRecords;
          }
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    // 获取表格列列表
    FetchGetTableColumnSettings(data) {
      FetchGetTableColumnSettings(data)
        .then(response => {
          let data = response;
          let showTableCols = [];
          let hideTableCols = [];
          if (data && data.result && Array.isArray(data.result)) {
            data.result.forEach(item => {
              if (item.show) {
                showTableCols.push(item);
              } else {
                hideTableCols.push(item);
              }
            });
          }
          this.showTableCols = showTableCols;
          this.hideTableCols = hideTableCols;
          this.copyShowTableCols = showTableCols;
          this.copyHideTableCols = hideTableCols;
          this.localShowTableCols = showTableCols;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 删除字典数据
    deleteTempAndHumiditySetByIdList(data) {
      deleteTempAndHumiditySetByIdList(data)
        .then(response => {
          let type = response.code === 1 ? "success" : "error";
          let message = response.message;
          this.$message({
            showClose: true,
            message: message,
            type: type,
            duration: 1500,
            onClose: () => {
              if (type === "success") {
                this.curPage = 1;
                this.FetchFindByPage(this.mergeObj());
              }
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },

    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },

    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },

    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },

    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },

    // 多选表格数据
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 打开确认删除面板
    handleBatchDeleteUser() {
      if (!this.ids.length) {
        return this.$message({
          showClose: true,
          message: "请至少选择一条温湿度标准设置",
          type: "warning",
          duration: 1200
        });
      }
      this.$confirm("确定批量删除温湿度标准设置吗？", "批量删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      })
        .then(() => {
          this.deleteTempAndHumiditySetByIdList({ alarmIdList: this.ids });
        })
        .catch(() => {});
    },

    // 单个操作删除
    handelDelete(id) {
      this.$confirm("确定删除该温湿度标准设置吗？", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      })
        .then(() => {
          // 确认删除操作
          this.deleteTempAndHumiditySetByIdList({ alarmIdList: [id] });
        })
        .catch(() => {});
    },

    // 新增 or 修改 温湿度标准 dialog 打开
    handleHumitureStandard(status, id) {
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      this.initRuleForm();
      if (status === "add") {
        this.dialogTitle = "新增";
        this.ruleForm.alarmId && delete this.ruleForm.alarmId;
      } else {
        this.dialogTitle = "修改";
        this.messageChange(id);
      }
      this.dialogVisible = true;
    },

    async messageChange(id) {
      try {
        let obj = {};
        let cname = "";
        this.dialogLoding = true;
        let { code, result } = await findTempAndHumiditySetInfoById({
          alarmId: id
        });
        if (code === 1 && result) {
          obj = result;
          obj.isUse = Boolean(obj.isUse);
          obj.temperatureIsUse = Boolean(obj.temperatureIsUse);
          obj.humidityIsUse = Boolean(obj.humidityIsUse);
          obj.humidityHigh = obj.humidityHigh === 0 ? "" : obj.humidityHigh;
          obj.humidityLow = obj.humidityLow === 0 ? "" : obj.humidityLow;
          obj.isUseRange = Boolean(obj.isUseRange);
          obj.isUseDuration = Boolean(obj.isUseDuration);
          obj.outTempLow = obj.outTempLow === 0 ? "" : obj.outTempLow;
          obj.outTempHigh = obj.outTempHigh === 0 ? "" : obj.outTempHigh;
          obj.outHumidityHigh =
            obj.outHumidityHigh === 0 ? "" : obj.outHumidityHigh;
          obj.outHumidityLow =
            obj.outHumidityLow === 0 ? "" : obj.outHumidityLow;
          obj.humidityContinuedTime =
            obj.humidityContinuedTime === 0 ? "" : obj.humidityContinuedTime;
          obj.tempContinuedTime =
            obj.tempContinuedTime === 0 ? "" : obj.tempContinuedTime;
          cname = obj.tempAndHumidityStandardName;
        }
        this.cname = cname;
        this.ruleForm = obj;
      } catch (err) {
        console.log(err);
      } finally {
        this.dialogLoding = false;
      }
    },

    // 新增 or 修改 温湿度标准表单提交
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = cloneDeep(this.ruleForm);
          param.tempHigh = Number(param.tempHigh);
          param.tempLow = Number(param.tempLow);
          param.isUse = Number(param.isUse);
          param.temperatureIsUse = Number(param.temperatureIsUse);
          param.humidityIsUse = Number(param.humidityIsUse);
          param.isUseRange = Number(param.isUseRange);
          param.isUseDuration = Number(param.isUseDuration);
          if (!param.isUseRange) {
            param.outTempLow = 0;
            param.outTempHigh = 0;
            param.outHumidityHigh = 0;
            param.outHumidityLow = 0;
          }
          if (!param.isUseDuration) {
            param.tempContinuedTime = 0;
            param.humidityContinuedTime = 0;
          }
          this.saveSubmit(param);
        }
      });
    },

    // 提交
    async saveSubmit(data) {
      try {
        this.dialogLoding = true;
        // 请求接口
        let { code, message } = await saveTempAndHumiditySet(data);
        if (code === 1) {
          this.$message.success(message || "成功新增温湿度标准");
          this.initRuleForm();
          this.dialogVisible = false;
          this.FetchFindByPage(this.mergeObj());
          this.FetchHumitureName();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.dialogLoding = false;
      }
    },

    initRuleForm() {
      this.ruleForm = {
        tempAndHumidityStandardName: "", // 标准名称
        tempHigh: "", // 温度上限
        tempLow: "", // 温度下限
        tempContinuedTime: "", //温度报警时间
        humidityHigh: "", // 湿度上限
        humidityLow: "", // 湿度下限
        humidityContinuedTime: "", // 湿度报警时间
        isUse: true, // 开关一
        temperatureIsUse: true, // 开关二
        humidityIsUse: true, // 开关三
        outTempLow: "",
        outTempHigh: "",
        outHumidityHigh: "",
        outHumidityLow: "",
        isUseRange: false,
        isUseDuration: false
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.form-extend {
  .form-item_2 {
    width: 190px;
    /deep/.el-form-item--mini .el-form-item__content {
      width: 190px;
    }
    /deep/.el-select {
      width: 190px;
      .el-select__tags {
        max-width: 175px !important;
      }
      .el-select__tags-text {
        display: inline-block;
        max-width: 120px;
        text-overflow: ellipsis;
        overflow: hidden;
        vertical-align: middle;
      }
    }
  }
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;

  // 表格操作列
  .operate {
    .item {
      color: #03a9f4;
      margin: 0 5px;
      cursor: pointer;
    }
  }
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

// 增加 or 修改 温湿度标准弹框
/deep/ .standard-dialog {
  .el-dialog {
    min-width: 650px;

    .el-dialog__title {
      font-size: 16px;
    }
    .el-dialog__body {
      padding: 20px;
    }

    .el-dialog__header {
      padding: 10px;
      background-color: #efefef;

      .el-dialog__headerbtn {
        top: 15px;
      }
    }

    // 表单
    .ruleForm {
      // 标准名称
      .name {
        .el-form-item__content {
          width: 200px;
        }
      }

      // 温度or湿度要求
      .temp-require,
      .hum-require {
        .el-form-item--mini.el-form-item {
          margin-bottom: 0;
        }
        .el-form-item__content {
          width: 400px;
        }

        .require {
          .el-form-item__content {
            width: 100px;
          }
        }
      }

      //温度or湿度报警
      .alarm {
        .el-form-item__content {
          display: flex;
          flex-direction: row;
          align-items: center;

          .el-input.el-input--mini {
            width: 70px;
            margin: 0 3px;
          }
        }

        .el-form-item__error {
          left: 160px;
        }
      }

      .alarmRule {
        .el-col {
          //line-height: 36px;
          margin-bottom: 18px;
        }
        .el-form-item__label {
          //line-height: 36px;
          margin-bottom: 18px;
        }
      }
      // 表单操作按钮
      .operates-btn {
        text-align: center;
      }
    }
  }
}
</style>
